import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { ChevronRight, Left } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { PageHeader } from '../../../components/PageHeader';
import { selectWorks } from '../../Api/selectors';
import { exportData, fetchCompany } from '../actions';
import { REQUEST_COMPANY } from '../constants';
import { selectCompanies, selectCompany } from '../selectors';
import { CompanyDetailsColumns } from './detailsColumns';
import { CompanyDetailsVars } from './detailsVars';
import { CompanyDun } from './CompanyDun';
import { WithCompany } from '../components/WithCompany';
import { Modal } from '../../../components/Modal';
import LoadingDetailsPage from '../../../containers/App/Components/LoadingDetailsPage/LoadingDetailsPage';
import { CompanyDetailsHistory } from './detailsHistory';

const Container = styled.div`
  .content {
    display: inline-block;
    width: 100%;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CompanyDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    this.props.fetch();
  }

  get company() {
    return this.props.company;
  }

  render() {
    if (this.props.work)
      return (
        <>
          <PageHeader
            title={
              <div onClick={this.tofn('/companies')}>
                <Left />
                {this.lbl('companies.overview.title')}
              </div>
            }
            breadCrumbs={
              <>
                <a href="/">Vindat</a>
                <ChevronRight />
                {this.lbl('company.overview.title')}
              </>
            }
          />
          <LoadingDetailsPage version="versionCompanies" />
        </>
      );
    if (!this.company) return '';
    console.log('this.company.name', this.company);
    return (
      <div className="container-fluid p-0">
        <PageHeader
          title={
            <div onClick={this.tofn('/companies')}>
              <Left />
              {this.lbl('companies.overview.title')}
            </div>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('company.overview.title')}
              <ChevronRight />
              {this.company.name}
            </>
          }
        />
        <Switch>
          <Route path="(.*)/vars" render={component => <CompanyDetailsVars company={this.company} />} />
          <Route path="(.*)/dun" render={component => <CompanyDun company={this.company} />} />
          <Route path="(.*)/history" render={component => <CompanyDetailsHistory company={this.company} />} />
          <Route render={component => <CompanyDetailsColumns company={this.company} />} />
        </Switch>
      </div>
    );
  }
}

CompanyDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    company: selectCompany(ownProps.company_id),
    work: selectWorks([REQUEST_COMPANY]),
    companies: selectCompanies(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchCompany(ownProps.company_id));
    },
    fetchCompany: (companyId, callback) => {
      dispatch(fetchCompany(companyId, callback));
    },
    exportData: (companyId, callback) => {
      dispatch(exportData(companyId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyDetails = compose(withConnect, withRouter)(CompanyDetailsComp);
